//import constants.js here
import {constants} from './constants';
import {debugConstants} from './debug-constants';
import {createResultModal} from './resultModal';
import {createStatsModal,  updateModal} from './stats';

// import for pushing/pulling data from url.
import pushToUrl from "push-data-to-url";

import {
  Stage,
  Shape,
  Text,
  Bitmap,
  Ticker,
  Container
} from "@createjs/easeljs";

import {Tween, Ease} from "@createjs/tweenjs";
import simulation from './simulation.js';
import {reset} from './simulation.js';

let urlPush = new pushToUrl();
// set the default constants data.
let constantsData = constants;
// boolean flag for whether the rocket has entered the falling stage.
let falling = false;
//boolean flag for if the new url has been updated after the simulation has run.
let urlUpdated = false;
//boolean flag for if the url data has been parsed into the simulation values.
let paramsUpdated = false;

let isDebugEnabled = false;
let dragPopupOpen = false;
let massPopupOpen = false;


function formatNumber(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
var imageManifest = [
    {id: 'bg', src: "../src/images/main-overlay-2.svg", type:createjs.Types.IMAGE},
    {id: 'waterColorBase', src: "../src/images/water-one.png", type:createjs.Types.IMAGE},
    {id: 'waterColorBaseTwo', src: "../src/images/water-two.png", type:createjs.Types.IMAGE},
    {id: 'stars', src: "../src/images/stars.svg", type:createjs.Types.IMAGE},
    {id: 'waterColorOne', src: "../src/images/water-one.png", type:createjs.Types.IMAGE},
    {id: 'waterColorTwo', src: "../src/images/water-two.png", type:createjs.Types.IMAGE},
    {id: 'sun', src: "../src/images/sun.svg", type:createjs.Types.IMAGE},
    {id: 'sunReflection', src: "../src/images/sun-reflection.svg", type:createjs.Types.IMAGE},
    {id: 'sunReflectionTwo', src: "../src/images/sun-reflection-two.svg", type:createjs.Types.IMAGE},
    {id: 'sea', src: "../src/images/sea.svg", type:createjs.Types.IMAGE},
    {id: 'grass', src: "../src/images/landscape-v3.png", type:createjs.Types.IMAGE},
    {id: 'rocketBody', src: "../src/images/rocket-body.svg", type:createjs.Types.IMAGE},
    {id: 'satellite', src: "../src/images/payload-plate.svg", type:createjs.Types.IMAGE},
    {id: 'rocketPayload', src: "../src/images/payload.svg", type:createjs.Types.IMAGE},
    {id: 'crane', src: "../src/images/arm.svg", type:createjs.Types.IMAGE},
    {id: 'platform', src: "../src/images/platform-v2.svg", type:createjs.Types.IMAGE},
    {id: 'rocketPayloadLeft', src: "../src/images/payload-left.svg", type:createjs.Types.IMAGE},
    {id: 'rocketPayloadRight', src: "../src/images/payload-right.svg", type:createjs.Types.IMAGE},
    {id: 'platformFlame', src: "../src/images/platform-flame.svg", type:createjs.Types.IMAGE},
    {id: 'geese', src: "../src/images/geese.svg", type:createjs.Types.IMAGE},
    {id: 'lowLevelPlane', src: "../src/images/aeroplane.svg", type:createjs.Types.IMAGE},
    {id: 'windowGlass', src: "../src/images/window-glass.svg", type:createjs.Types.IMAGE},
    {id: 'biggerFlame', src: "../src/images/flame-v2.svg", type:createjs.Types.IMAGE},
    {id: 'biggerFlameTwo', src: "../src/images/flame-v2-2.svg", type:createjs.Types.IMAGE},
    {id: 'launchSmoke', src: "../src/images/smoke.png", type:createjs.Types.IMAGE},
    {id: 'launchSmokeGroup', src: "../src/images/smoke-group.png", type:createjs.Types.IMAGE},
    {id: 'launchExplosion', src: "../src/images/smoke-explode.png", type:createjs.Types.IMAGE},
    {id: 'launchBigExplosion', src: "../src/images/big-explosion.png", type:createjs.Types.IMAGE},
    {id: 'feedbackBorderYellow', src: '../src/images/feedback-popup-border-yellow.svg', type:createjs.Types.IMAGE},
    {id: 'feedbackBorderGreen', src: '../src/images/feedback-popup-border-green.svg', type:createjs.Types.IMAGE},
    {id: 'feedbackBorderRed', src: '../src/images/feedback-popup-border-red.svg', type:createjs.Types.IMAGE},
  ];


$('#rocket-play-speed-ul').hide();
// open popup when info icon is clicked, close it if pressed again.
$('#mass-info').on('click', () => {
  if (massPopupOpen) {
    $('#mass-info-popup').hide(200);
    massPopupOpen = false;
  } else {
    $('#mass-info-popup').show(200);
    massPopupOpen = true;
  }
});
//close popup when the 'x' is pressed on the popup.
$('#mass-info-popup-close').on('click', () => {
  $('#mass-info-popup').hide(200);
  massPopupOpen = false;
});

$('#drag-info').on('click', () => {
  if (dragPopupOpen) {
    $('#drag-info-popup').hide(200);
    dragPopupOpen = false;
  } else {
    $('#drag-info-popup').show(200);
    dragPopupOpen = true;
  }
});
//close popup when the 'x' is pressed on the popup.
$('#drag-info-popup-close').on('click', () => {
  $('#drag-info-popup').hide(200);
  dragPopupOpen = false;
});

$(function () {

  $("#mass-range").slider({
    orientation: "vertical",
    value: constants.initialMass,
    min: constants.minMass,
    max: constants.maxMass,
    range: 'min',
    step: 10,
    slide: function (event, ui) {
      document.getElementById("mass").innerHTML = ui.value;
      document.getElementById("mass-read").innerHTML = formatNumber( ui.value );
      return checkMass();
    }
  });
  document.getElementById("mass").innerHTML = $("#mass-range").slider("value");
  document.getElementById("mass-read").innerHTML = formatNumber( $("#mass-range").slider("value") );




  $("#thrust-range").slider({
    orientation: "vertical",
    value: constants.initialThrust,
    min: constants.minThrust,
    max: constants.maxThrust,
    range: 'min',
    step: 100,
    slide: function (event, ui) {
      document.getElementById("thrust").innerHTML = ui.value;
      document.getElementById("thrust-read").innerHTML = formatNumber( ui.value );
      checkMass();
    }
  });
  document.getElementById("thrust").innerHTML = $("#thrust-range").slider("value");
  document.getElementById("thrust-read").innerHTML = formatNumber( $("#thrust-range").slider("value") );


  $("#time-range").slider({
    orientation: "vertical",
    value: 20,
    min: constants.minThrustTime,
    max: constants.maxThrustTime,
    step: constants.initialThrustTime,
    range: 'min',
    slide: function (event, ui) {
      document.getElementById("time").innerHTML = ui.value;
      checkMass();
    }
  });
  document.getElementById("time").innerHTML = $("#time-range").slider("value");

  //check the values again if the mass change checkbox is ticked
  $('#mass_change').bind('change', function () {
    checkMass();
  });

  // parse the url data if it exists, and update the sliders/inputs accordingly.
  initParams();

  /**
   * This will run once when the page loads. If there are params in the url,
   * it will parse them into the simulation.
   */
  function initParams() {
    //check that params haven't been updated yet. Return otherwise.
    if (paramsUpdated) {
      return;
    }

    //get all the values from the url.
    let urlHost = urlPush.get('urlHost');
    let urlPage = urlPush.get('urlPage');
    let thrustVal = urlPush.get('thrust');
    let massVal = urlPush.get('mass');
    let thrustTimeVal = urlPush.get('thrustTime');
    let massChangeVal = urlPush.get('mass_change');
    let dragVal = urlPush.get('drag');

    //parse all the values if they exist.
    if (urlHost) {
      window.urlHostShare = urlHost;
    }else {
      var grabcurrent = window.location.href.toString();
      var stripehttp =  grabcurrent.replace(/(^\w+:|^)\/\//, '//');
      var grabdomain = stripehttp.split('?')[0];
      window.urlHostShare = grabdomain;
    }
    if (urlPage) {
      window.urlPageShare = urlPage;
    }else {
      window.urlPageShare = '';
    }

    if (thrustTimeVal) {
      $("#time-range").slider('value', thrustTimeVal);
      document.getElementById("time").innerHTML = thrustTimeVal;
    }
    if (thrustVal) {
      $("#thrust-range").slider('value', thrustVal);
      document.getElementById("thrust").innerHTML = thrustVal;
      document.getElementById("thrust-read").innerHTML =  formatNumber( Number( thrustVal ) );


    }
    if (massVal) {
      $("#mass-range").slider('value', massVal);
      document.getElementById("mass").innerHTML = massVal;
      document.getElementById("mass-read").innerHTML =  formatNumber( Number( massVal ) ) ;

    }
    if (massChangeVal) {
      if (massChangeVal == 'false') {
        $("#mass_change").prop("checked", false);
      } else {
        $("#mass_change").prop("checked", true);
      }
    }
    if (dragVal) {
      if (dragVal == 'false') {
        $("#drag").prop("checked", false);
      } else {
        $("#drag").prop("checked", true);
      }
    }

    //set field to true, so it doesn't update again.
    paramsUpdated = true;
  }

  /**
   * This adjusts the sliders so that the rocket mass cannot be less than the max
   * fuel mass. this only comes into effect if the mass change is selected
   */
  function checkMass() {
    //get the maximum fuel mass with the current thrust and thrust time values.
    let fuelMax = document.getElementById("time").innerHTML * document.getElementById("thrust").innerHTML
        * constants.fuelConstant;

    if ($('#mass_change').is(":checked")) {
      $("#slider").slider('option', {min: fuelMax, max: 500});
      if (document.getElementById("mass").innerHTML < fuelMax) {
      document.getElementById("mass").innerHTML=Math.ceil(fuelMax);
        $("#mass-range").slider('value', Math.ceil(fuelMax));
        var minMass = Math.round(fuelMax);
        document.getElementById("mass").innerHTML = minMass;
        document.getElementById("mass-read").innerHTML = formatNumber( minMass);
        return false;
      }
    }
    return true;
  }

  //  DEBUG PANEL STUFF

  /**
   * This is to update the text on the screen and the values in the text fields.
   */
  function updateText() {
    $("#density").val(debugConstants.airDensity);
    $("#gravity").val(debugConstants.gravity);
    $("#dragCoefficient").val(debugConstants.coefficientOfDrag);
    $("#stressCoefficient").val(debugConstants.stressCoefficient);
    $("#diameter").val(debugConstants.diameter);
    $("#payloadHeight").val(debugConstants.payloadHeight);


    document.getElementById("diameter-text").innerHTML =  constantsData.diameter;
    document.getElementById("gravity-text").innerHTML =  constantsData.gravity;
    document.getElementById("density-text").innerHTML =  constantsData.airDensity;

    stage.update();
  }

  //update the panel text
  updateText();

  //set up the listeners for t
  $('#use-debug').bind('change', function () {
    isDebugEnabled = $(this).is(":checked");
    // if debug mode, set the constants data to the debug data and update text fields.
    if (isDebugEnabled) {
      constantsData = debugConstants;
      updateText();
    } else {
      constantsData = constants;
      updateText();
    }

  });

  $('#density').on('input', function () {
    if ($(this).val() > 0) {
      debugConstants.airDensity = parseFloat($(this).val());
      if (isDebugEnabled) {

            document.getElementById("density-text").innerHTML =  $("#density").val();
        stage.update();
      }
    }
  });

  $('#gravity').on('input', function () {
    if ($(this).val() > 0) {
      debugConstants.gravity = parseFloat($(this).val());
      if (isDebugEnabled) {

            document.getElementById("gravity-text").innerHTML =  $("#gravity").val();
        stage.update();
      }

    }
  });

  $('#dragCoefficient').on('input', function () {
    if ($(this).val() > 0) {
      debugConstants.coefficientOfDrag = parseFloat($(this).val());
    }
  });

  $('#stressCoefficient').on('input', function () {
    if ($(this).val() > 0) {
      debugConstants.stressCoefficient = parseFloat($(this).val());

    }
  });

  $('#diameter').on('input', function () {
    if ($(this).val() > 0) {
      debugConstants.diameter = parseFloat($(this).val());
      if (isDebugEnabled) {

        document.getElementById("diameter-text").innerHTML =  $("#diameter").val();

        stage.update();
      }
    }
  });

  $('#payloadHeight').on('input', function () {
    if ($(this).val() > 0) {
      debugConstants.payloadHeight = parseFloat($(this).val());
    }
  });

  //reset values to the original constants and reset the text fields
  $('#reset').on('click', () => {
    debugConstants.airDensity = constants.airDensity;
    debugConstants.gravity = constants.gravity;
    debugConstants.coefficientOfDrag = constants.coefficientOfDrag;
    debugConstants.stressCoefficient = constants.stressCoefficient;
    debugConstants.diameter = constants.diameter;
    debugConstants.payloadHeight = constants.payloadHeight;
    updateText();
  });

  document.getElementById("diameter-text").innerHTML =  $("#diameter").val();
  document.getElementById("density-text").innerHTML =  $("#density").val();
  document.getElementById("gravity-text").innerHTML =  $("#gravity").val();

});

//Init Canvas Set Up
var stage = new Stage("myCanvas");
var queue = new createjs.LoadQueue();
queue.setMaxConnections(100);

//This is where it starts
var bg;
var sky;
var fillCommand;
var waterColorBase;
var waterColorBaseTwo;

var space;
var fillCommandSpace;
var stars;
var waterColorOne;
var waterColorTwo;
var waterColorThree;
var waterColorFour;

var sun;
var sunReflection;
var sunReflectionTwo;

var sea;
var grass;
var launchItems;
var crane;
var rocketBody;
var rocket;
var satellite;
var rocketPayload;
var rocketPayloadLeft;
var rocketPayloadRight;
var platform;
var platformFlame;

var geese;
var lowLevelPlane;
var highLevelPlane;
var windowGlass;
var leftWall;
var rightWall;
var topWall;
var warningLight;

var biggerFlame;
var biggerFlameTwo;
var launchFailureFlame;
var launchSmoke;
var launchSmokeTwo;
var launchSmokeThree;
var launchSmokeFour;
var launchSmokeFive;
var launchSmokeSix;
var launchSmokeSeven;
var launchSmokeEight;
var launchSmokeNine;
var launchSmokeTen;

var launchSmokeLarge;
var launchSmokeLargeTwo;
var launchSmokeLargeThree;
var launchSmokeLargeFour;
var launchSmokeLargeFive;
var launchSmokeLargeSix;
var launchSmokeLargeSeven;
var launchSmokeLargeEight;
var launchSmokeLargeNine;
var launchSmokeLargeTen;

var launchExplosion;
var launchExplosionTwo;
var launchExplosionThree;
var launchExplosionFour;
var launchExplosionFive;
var launchExplosionSix;
var launchExplosionSeven;
var launchExplosionEight;
var launchExplosionNine;
var launchExplosionTen;

var launchExplosionLarge;
var launchExplosionLargeTwo;
var launchExplosionLargeThree;
var launchExplosionLargeFour;
var launchExplosionLargeFive;
var launchExplosionLargeSix;
var launchExplosionLargeSeven;
var launchExplosionLargeEight;
var launchExplosionLargeNine;
var launchExplosionLargeTen;


var countdownOne;
var countdownTwo;
var countdownThree;
var resultModal;

var smallPlane;
var vFormation;
var largePlane;
var payloadDeploy;
var waterColorBg;
var inSpace;
var payloadRelease;
var heightTally;
var maxHeight;
var activeSimulation;

var launchTimeout;
var mainTimeout;
var restartTimeout;
var resultsTimeout;

var previousHeight;
var nextPreviousHeight;
var firstLaunch = true;

/**
 * Initialise the objects being used in the simulation including the initial fields and
 * graphics for simulation and results modals.
 */
function createObjects() {
  //This is where it starts

  bg = new Bitmap(queue.getResult('bg'));
  sky = new createjs.Shape();
  fillCommand = sky.graphics.beginFill("rgba(33,33,189,0)").command;
  waterColorBase = new Bitmap(queue.getResult('waterColorBase'));
  waterColorBaseTwo = new Bitmap(queue.getResult('waterColorBaseTwo'));

  space = new createjs.Shape();
  fillCommandSpace = space.graphics.beginFill("rgba(4,4,4,0)").command;
  stars = new Bitmap("../src/images/stars.svg");
  waterColorOne = new Bitmap(queue.getResult('waterColorOne'));
  waterColorTwo = new Bitmap(queue.getResult('waterColorTwo'));
  waterColorThree = new Bitmap(queue.getResult('waterColorThree'));
  waterColorFour = new Bitmap(queue.getResult('waterColorFour'));

  sun = new Bitmap(queue.getResult('sun'));
  sunReflection = new Bitmap(queue.getResult('sunReflection'));
  sunReflectionTwo = new Bitmap(queue.getResult('sunReflectionTwo'));

  sea = new Bitmap(queue.getResult('sea'));
  grass = new Bitmap(queue.getResult('grass'));
  rocket = new Container();
  rocketBody = new Bitmap(queue.getResult('rocketBody'));
  satellite = new Bitmap(queue.getResult('satellite'));
  rocketPayload = new Bitmap(queue.getResult('rocketPayload'));
  launchItems = new Container();
  crane = new Bitmap(queue.getResult('crane'));
  platform = new Bitmap(queue.getResult('platform'));
  rocketPayloadLeft = new Bitmap(queue.getResult('rocketPayloadLeft'));
  rocketPayloadRight = new Bitmap(queue.getResult('rocketPayloadRight'));
  platformFlame = new Bitmap(queue.getResult('platformFlame'));

  geese = new Bitmap(queue.getResult('geese'));
  lowLevelPlane = new Bitmap(queue.getResult('lowLevelPlane'));
  highLevelPlane = new Bitmap(queue.getResult('highLevelPlane'));
  windowGlass = new Bitmap(queue.getResult('windowGlass'));
  leftWall = new Shape();
  rightWall = new Shape();
  topWall = new Shape();
  warningLight = new Shape();

  biggerFlame = new Bitmap(queue.getResult('biggerFlame'));
  biggerFlameTwo = new Bitmap(queue.getResult('biggerFlameTwo'));
  biggerFlameTwo = new Bitmap(queue.getResult('biggerFlameTwo'));
  launchFailureFlame = new Bitmap(queue.getResult('platformFlame'));
  launchSmoke = new Bitmap(queue.getResult('launchSmoke'));
  launchSmokeTwo = new Bitmap(queue.getResult('launchSmoke'));
  launchSmokeThree = new Bitmap(queue.getResult('launchSmoke'));
  launchSmokeFour = new Bitmap(queue.getResult('launchSmoke'));
  launchSmokeFive = new Bitmap(queue.getResult('launchSmoke'));
  launchSmokeSix = new Bitmap(queue.getResult('launchSmoke'));
  launchSmokeSeven = new Bitmap(queue.getResult('launchSmoke'));
  launchSmokeEight = new Bitmap(queue.getResult('launchSmoke'));
  launchSmokeNine = new Bitmap(queue.getResult('launchSmoke'));
  launchSmokeTen = new Bitmap(queue.getResult('launchSmoke'));

  launchSmokeLarge = new Bitmap(queue.getResult('launchSmokeGroup'));
  launchSmokeLargeTwo = new Bitmap(queue.getResult('launchSmokeGroup'));
  launchSmokeLargeThree = new Bitmap(queue.getResult('launchSmokeGroup'));
  launchSmokeLargeFour = new Bitmap(queue.getResult('launchSmokeGroup'));
  launchSmokeLargeFive = new Bitmap(queue.getResult('launchSmokeGroup'));
  launchSmokeLargeSix = new Bitmap(queue.getResult('launchSmokeGroup'));
  launchSmokeLargeSeven = new Bitmap(queue.getResult('launchSmokeGroup'));
  launchSmokeLargeEight = new Bitmap(queue.getResult('launchSmokeGroup'));
  launchSmokeLargeNine = new Bitmap(queue.getResult('launchSmokeGroup'));
  launchSmokeLargeTen = new Bitmap(queue.getResult('launchSmokeGroup'));

  launchExplosion = new Bitmap(queue.getResult('launchExplosion'));
  launchExplosionTwo = new Bitmap(queue.getResult('launchExplosion'));
  launchExplosionThree = new Bitmap(queue.getResult('launchExplosion'));
  launchExplosionFour = new Bitmap(queue.getResult('launchExplosion'));
  launchExplosionFive = new Bitmap(queue.getResult('launchExplosion'));
  launchExplosionSix = new Bitmap(queue.getResult('launchExplosion'));
  launchExplosionSeven = new Bitmap(queue.getResult('launchExplosion'));
  launchExplosionEight = new Bitmap(queue.getResult('launchExplosion'));
  launchExplosionNine = new Bitmap(queue.getResult('launchExplosion'));
  launchExplosionTen = new Bitmap(queue.getResult('launchExplosion'));

  launchExplosionLarge = new Bitmap(queue.getResult('launchExplosionLarge'));
  launchExplosionLargeTwo = new Bitmap(queue.getResult('launchExplosionLarge'));
  launchExplosionLargeThree = new Bitmap(queue.getResult('launchExplosionLarge'));
  launchExplosionLargeFour = new Bitmap(queue.getResult('launchExplosionLarge'));
  launchExplosionLargeFive = new Bitmap(queue.getResult('launchExplosionLarge'));
  launchExplosionLargeSix = new Bitmap(queue.getResult('launchExplosionLarge'));
  launchExplosionLargeSeven = new Bitmap(queue.getResult('launchExplosionLarge'));
  launchExplosionLargeEight = new Bitmap(queue.getResult('launchExplosionLarge'));
  launchExplosionLargeNine = new Bitmap(queue.getResult('launchExplosionLarge'));
  launchExplosionLargeTen = new Bitmap(queue.getResult('launchExplosionLarge'));

  countdownOne = new Text("1", "200px Arial", "#282828");
  countdownTwo = new Text("2", "200px Arial", "#282828");
  countdownThree = new Text("3", "200px Arial", "#282828");

  smallPlane = false;
  vFormation = false;
  largePlane = false;
  payloadDeploy = false;
  waterColorBg = false;
  inSpace = false;
  payloadRelease = false;
  heightTally = new Text("0", "20px Arial", "green");
  maxHeight = new Text("0", "20px Arial", "green");
  activeSimulation = simulation;
}

/**
 * Set up the graphics for the canvas. This includes all the text, images and other
 * UI elements on the canvas that are displayed throughout the simulation.
 */
function setStage() {

  $("#rocket-restart").hide();
  $("#rocket-URL").hide();
  // $("#rocket-URL-text").hide();
  $("#rocket-wrapper").removeClass("sim-active");
//Background Set Up
  sky.graphics.drawRect(0, 0, 800, 650);
  stage.addChild(sky);

  waterColorBase.x = 0;
  waterColorBase.y = -100;
  waterColorBase.alpha = 0.1;
  stage.addChild(waterColorBase);

  waterColorBaseTwo.x = 0;
  waterColorBaseTwo.y = 100;
  waterColorBaseTwo.alpha = 0.1;
  stage.addChild(waterColorBaseTwo);

  space.graphics.drawRect(0, 0, 800, 650);
  stage.addChild(space);

  stars.x = 0;
  stars.y = 0;
  stage.addChild(stars);

  waterColorOne.x = 0;
  waterColorOne.y = -800;
  waterColorOne.alpha = 0.1;
  stage.addChild(waterColorOne);

  waterColorTwo.x = 0;
  waterColorTwo.y = -800;
  waterColorTwo.alpha = 0.1;
  stage.addChild(waterColorTwo);

  waterColorThree.x = 0;
  waterColorThree.y = -800;
  waterColorThree.alpha = 0.1;
  stage.addChild(waterColorThree);

  waterColorFour.x = 0;
  waterColorFour.y = -800;
  waterColorFour.alpha = 0.1;
  stage.addChild(waterColorFour);

  sun.x = 560;
  sun.y = 290;
  sun.alpha = 1;
  sun.scale = .6;
  stage.addChild(sun);


//Init Landscape

  sea.x = 0;
  sea.y = 450;
  stage.addChild(sea);

  sunReflection.x = 520;
  sunReflection.y = 450;
  sunReflection.alpha = .5;
  stage.addChild(sunReflection);

  sunReflectionTwo.x = 600;
  sunReflectionTwo.y = 470;
  sunReflectionTwo.alpha = .3;
  stage.addChild(sunReflectionTwo);

  grass.x = -1550;
  grass.y = 515;
  grass.scale = 2;
  // stage.addChild(grass);


  crane.x = 310;
  crane.y = 325;
  crane.scale = .17;
  // stage.addChild(crane);

//Rocket

  rocket.x = 388;
  rocket.y = 247;
  rocketBody.y = 49;
  rocket.addChild(rocketBody);
  rocket.addChild(rocketPayload);

  rocketPayload.alpha = 1;

  launchItems.regX = 400;
  launchItems.regY = 325;
  launchItems.x = 400;
  launchItems.y = 150;

  launchItems.scale = 0.8;
  launchItems.addChild(grass, crane, platform, rocket);
  stage.addChild(launchItems);

  satellite.alpha = 0;
  satellite.x = 388;
  satellite.y = 220;
  satellite.scale = .05;
  stage.addChild(satellite);

  rocketPayloadLeft.x = 388;
  rocketPayloadLeft.y = 70;
  rocketPayloadLeft.alpha = 0;
  stage.addChild(rocketPayloadLeft);

  rocketPayloadRight.x = 403;
  rocketPayloadRight.y = 70;
  rocketPayloadRight.alpha = 0;
  stage.addChild(rocketPayloadRight);

//Part of Landscape but Infront of Rocket

  platform.x = 290;
  platform.y = 545;
  platform.alpha = 1;
  platform.scale = .2;
  // stage.addChild(platform);

  platformFlame.x = 419;
  platformFlame.y = 591;
  platformFlame.alpha = 0;
  platformFlame.scale = .2;
  stage.addChild(platformFlame);

//Sky Elements

  geese.x = 600;
  geese.y = -200;
  stage.addChild(geese);

  lowLevelPlane.x = 600;
  lowLevelPlane.y = -200;
  stage.addChild(lowLevelPlane);

  highLevelPlane.x = 600;
  highLevelPlane.y = -200;
  stage.addChild(highLevelPlane);

//Lab
  windowGlass.alpha = 1;
  windowGlass.x = 0;
  windowGlass.y = 0;
  stage.addChild(windowGlass);

  leftWall.graphics.beginFill("#383838").drawRect(0, 0, 20, 650);
  leftWall.alpha = 1;
  leftWall.x = 0;
  leftWall.y = 0;
  stage.addChild(leftWall);

  rightWall.graphics.beginFill("#383838").drawRect(780, 0, 20, 650);
  rightWall.x = 0;
  rightWall.y = 0;
  rightWall.alpha = 1;

  stage.addChild(rightWall);

  topWall.graphics.beginFill("#383838").drawRect(0, 0, 800, 20);
  topWall.alpha = 1;
  topWall.x = 0;
  topWall.y = 0;
  stage.addChild(topWall);

  warningLight.graphics.beginFill("#f50a12").drawCircle(0, 0, 3);
  warningLight.x = 400;
  warningLight.y = 390;
  warningLight.alpha = 0;
  stage.addChild(warningLight);

//Rocket Launch: Init Flames

  biggerFlame.x = 387;
  biggerFlame.y = 576;
  biggerFlame.alpha = 0;
  biggerFlame.scale = .167;
  stage.addChild(biggerFlame);

  biggerFlameTwo.x = 384;
  biggerFlameTwo.y = 576;
  biggerFlameTwo.alpha = 0;
  biggerFlameTwo.scale = .167;
  stage.addChild(biggerFlameTwo);

  launchFailureFlame.x = 348;
  launchFailureFlame.y = 591;
  launchFailureFlame.alpha = 0;
  stage.addChild(launchFailureFlame);



//Rocket Launch: Init Smoke

launchSmoke.x = 300;
launchSmoke.y = 450;
launchSmoke.alpha = 0;
stage.addChild(launchSmoke);

launchSmokeTwo.x = 320;
launchSmokeTwo.y = 430;
launchSmokeTwo.alpha = 0;
stage.addChild(launchSmokeTwo);

launchSmokeThree.x = 280;
launchSmokeThree.y = 430;
launchSmokeThree.alpha = 0;
stage.addChild(launchSmokeThree);

launchSmokeFour.x = 250;
launchSmokeFour.y = 380;
launchSmokeFour.alpha = 0;
stage.addChild(launchSmokeFour);

launchSmokeFive.x = 260;
launchSmokeFive.y = 420;
launchSmokeFive.alpha = 0;
stage.addChild(launchSmokeFive);

  launchSmokeSix.x = 270;
  launchSmokeSix.y = 410;
  launchSmokeSix.alpha = 0;
  stage.addChild(launchSmokeSix);
  launchSmokeSeven.x = 285;
  launchSmokeSeven.y = 435;
  launchSmokeSeven.alpha = 0;
  stage.addChild(launchSmokeSeven);

  launchSmokeEight.x = 285;
  launchSmokeEight.y = 435;
  launchSmokeEight.alpha = 0;
  stage.addChild(launchSmokeEight);

  launchSmokeNine.x = 285;
  launchSmokeNine.y = 435;
  launchSmokeNine.alpha = 0;
  stage.addChild(launchSmokeNine);

  launchSmokeTen.x = 285;
  launchSmokeTen.y = 435;
  launchSmokeTen.alpha = 0;
  stage.addChild(launchSmokeTen);

  launchSmokeLarge.x = 300;
  launchSmokeLarge.y = 450;
  launchSmokeLarge.alpha = 0;
  stage.addChild(launchSmokeLarge);

  launchSmokeLargeTwo.x = 120;
  launchSmokeLargeTwo.y = 430;
  launchSmokeLargeTwo.alpha = 0;
  stage.addChild(launchSmokeLargeTwo);

  launchSmokeLargeThree.x = 80;
  launchSmokeLargeThree.y = 330;
  launchSmokeLargeThree.alpha = 0;
  stage.addChild(launchSmokeLargeThree);

  launchSmokeLargeFour.x = 250;
  launchSmokeLargeFour.y = 380;
  launchSmokeLargeFour.alpha = 0;
  stage.addChild(launchSmokeLargeFour);

  launchSmokeLargeFive.x = 60;
  launchSmokeLargeFive.y = 420;
  launchSmokeLargeFive.alpha = 0;
  stage.addChild(launchSmokeLargeFive);

  launchSmokeLargeSix.x = 70;
  launchSmokeLargeSix.y = 310;
  launchSmokeLargeSix.alpha = 0;
  stage.addChild(launchSmokeLargeSix);

  launchSmokeLargeSeven.x = 285;
  launchSmokeLargeSeven.y = 335;
  launchSmokeLargeSeven.alpha = 0;
  stage.addChild(launchSmokeLargeSeven);

  launchSmokeLargeEight.x = 285;
  launchSmokeLargeEight.y = 335;
  launchSmokeLargeEight.alpha = 0;
  stage.addChild(launchSmokeLargeEight);

  launchSmokeLargeNine.x = 85;
  launchSmokeLargeNine.y = 335;
  launchSmokeLargeNine.alpha = 0;
  stage.addChild(launchSmokeLargeNine);

  launchSmokeLargeTen.x = 285;
  launchSmokeLargeTen.y = 335;
  launchSmokeLargeTen.alpha = 0;
  stage.addChild(launchSmokeLargeTen);
//Explosion

  launchExplosion.x = 200;
  launchExplosion.y = 450;
  launchExplosion.alpha = 0;
  launchExplosion.scale = 1;
  stage.addChild(launchExplosion);

  launchExplosionTwo.x = 220;
  launchExplosionTwo.y = 430;
  launchExplosionTwo.alpha = 0;
  launchExplosionTwo.scale = 1;
  stage.addChild(launchExplosionTwo);

  launchExplosionThree.x = 180;
  launchExplosionThree.y = 430;
  launchExplosionThree.alpha = 0;
  launchExplosionThree.scale = 1;
  stage.addChild(launchExplosionThree);

  launchExplosionFour.x = 150;
  launchExplosionFour.y = 380;
  launchExplosionFour.alpha = 0;
  launchExplosionFour.scale = 1;
  stage.addChild(launchExplosionFour);

  launchExplosionFive.x = 160;
  launchExplosionFive.y = 420;
  launchExplosionFive.alpha = 0;
  launchExplosionFive.scale = 1;
  stage.addChild(launchExplosionFive);

  launchExplosionSix.x = 170;
  launchExplosionSix.y = 410;
  launchExplosionSix.alpha = 0;
  launchExplosionSix.scale = 1;
  stage.addChild(launchExplosionSix);

  launchExplosionSeven.x = 185;
  launchExplosionSeven.y = 435;
  launchExplosionSeven.alpha = 0;
  launchExplosionSeven.scale = 1;
  stage.addChild(launchExplosionSeven);

  launchExplosionEight.x = 185;
  launchExplosionEight.y = 435;
  launchExplosionEight.alpha = 0;
  launchExplosionEight.scale = 1;
  stage.addChild(launchExplosionEight);

  launchExplosionNine.x = 185;
  launchExplosionNine.y = 435;
  launchExplosionNine.alpha = 0;
  launchExplosionNine.scale = 1;
  stage.addChild(launchExplosionNine);

  launchExplosionTen.x = 185;
  launchExplosionTen.y = 435;
  launchExplosionTen.alpha = 0;
  launchExplosionTen.scale = 1;
  stage.addChild(launchExplosionTen);


  launchExplosionLarge.x = 200;
  launchExplosionLarge.y = 350;
  launchExplosionLarge.alpha = 0;
  launchExplosionLarge.scale = 1;
  stage.addChild(launchExplosionLarge);

  launchExplosionLargeTwo.x = 220;
  launchExplosionLargeTwo.y = 330;
  launchExplosionLargeTwo.alpha = 0;
  launchExplosionLargeTwo.scale = 1;
  stage.addChild(launchExplosionLargeTwo);

  launchExplosionLargeThree.x = 180;
  launchExplosionLargeThree.y = 430;
  launchExplosionLargeThree.alpha = 0;
  launchExplosionLargeThree.scale = 1;
  stage.addChild(launchExplosionLargeThree);

  launchExplosionLargeFour.x = 150;
  launchExplosionLargeFour.y = 280;
  launchExplosionLargeFour.alpha = 0;
  launchExplosionLargeFour.scale = 1;
  stage.addChild(launchExplosionLargeFour);

  launchExplosionLargeFive.x = 160;
  launchExplosionLargeFive.y = 220;
  launchExplosionLargeFive.alpha = 0;
  launchExplosionLargeFive.scale = 1;
  stage.addChild(launchExplosionLargeFive);

  launchExplosionLargeSix.x = 170;
  launchExplosionLargeSix.y = 210;
  launchExplosionLargeSix.alpha = 0;
  launchExplosionLargeSix.scale = 1;
  stage.addChild(launchExplosionLargeSix);

  launchExplosionLargeSeven.x = 185;
  launchExplosionLargeSeven.y = 235;
  launchExplosionLargeSeven.alpha = 0;
  launchExplosionLargeSeven.scale = 1;
  stage.addChild(launchExplosionLargeSeven);

  launchExplosionLargeEight.x = 185;
  launchExplosionLargeEight.y = 235;
  launchExplosionLargeEight.alpha = 0;
  launchExplosionLargeEight.scale = 1;
  stage.addChild(launchExplosionLargeEight);

  launchExplosionLargeNine.x = 185;
  launchExplosionLargeNine.y = 235;
  launchExplosionLargeNine.alpha = 0;
  launchExplosionLargeNine.scale = 1;
  stage.addChild(launchExplosionLargeNine);

  launchExplosionLargeTen.x = 185;
  launchExplosionLargeTen.y = 235;
  launchExplosionLargeTen.alpha = 0;
  launchExplosionLargeTen.scale = 1;
  stage.addChild(launchExplosionLargeTen);


// Countdown Timer

  countdownOne.x = 400;
  countdownOne.y = 350;
  countdownOne.alpha = 0;
  countdownOne.textAlign = 'center';
  countdownOne.textBaseline = 'middle';
  stage.addChild(countdownOne);

  countdownTwo.x = 400;
  countdownTwo.y = 350;
  countdownTwo.alpha = 0;
  countdownTwo.textAlign = 'center';
  countdownTwo.textBaseline = 'middle';
  stage.addChild(countdownTwo);

  countdownThree.x = 400;
  countdownThree.y = 350;
  countdownThree.alpha = 0;
  countdownThree.textAlign = 'center';
  countdownThree.textBaseline = 'middle';
  stage.addChild(countdownThree);

  stage.update();

//Create text option to output height

  heightTally.x = 50;
  heightTally.y = 250;
  heightTally.alpha = 0;
  stage.addChild(heightTally);

//max

  maxHeight.x = 50;
  maxHeight.y = 300;
  maxHeight.alpha = 0;
  stage.addChild(maxHeight);

  // set up the background
  bg.alpha = 0;
  bg.x = 13;
  bg.y = 6;
  bg.scaleX=1.43;
  bg.scaleY=1.43;
  stage.addChild(bg);

}

function handleAssetsLoaded() {
  createObjects();
  setStage();
  stage.update();
}

function handleLoaderProgress(event) {
  if (event.loaded == 1) {
    $("#loadingScreen").delay(500).fadeOut(1000, 'swing');
  }
  $("#progressBar").text(`${Math.round(event.loaded * 100)}%`);
}

//create the objects and set the stage.
queue.on('complete', handleAssetsLoaded, this);
queue.on('progress', handleLoaderProgress, this);
queue.loadManifest(imageManifest);


$('#submit').on('click', () => {
  running = true;
  $("#challenge-box").hide(400);

  $("#rocket-wrapper").addClass("sim-active");
  launchTimeout = null;
  mainTimeout = null;
  restartTimeout = null;
  resultsTimeout = null;
  reset();

  // set up the objects on the launch pad before simulation begins.
  initialiseLaunchPad();

  launchTimeout = setTimeout(() => {
    document.getElementById("rocket-controls").style.zIndex=-1;
        showingReset = false;
      //Thrusters activate Smoke and init Flame
      Tween.get(launchSmokeLarge, {loop: false})
          .to({alpha: 1, y: 370}, 1200, Ease.linear);
      Tween.get(launchSmokeLargeTwo, {loop: false})
          .to({alpha: 1}, 1200, Ease.linear);
      Tween.get(launchSmokeLargeThree, {loop: false})
          .to({alpha: 1, y: 1200}, 600, Ease.linear);
      Tween.get(launchSmokeLargeFour, {loop: false})
          .to({alpha: 1}, 1200, Ease.linear);
      Tween.get(launchSmokeLargeFive, {loop: false})
          .to({alpha: 1}, 1200, Ease.linear);
      Tween.get(launchSmokeLargeSix, {loop: false})
          .to({alpha: 1, y: 320}, 1000, Ease.linear);
      Tween.get(launchSmokeLargeSeven, {loop: false})
          .to({alpha: 1}, 1000, Ease.linear);
      Tween.get(launchSmokeLargeSeven, {loop: false})
          .to({y: 270}, 3000, Ease.linear);
      Tween.get(launchSmokeLargeEight, {loop: false})
          .to({alpha: 1, y: 370}, 400, Ease.linear);
      Tween.get(launchSmokeLargeNine, {loop: false})
          .to({alpha: 1}, 200, Ease.linear);
      Tween.get(launchSmokeLargeTen, {loop: false})
          .to({alpha: 1, y: 370}, 600, Ease.linear);

      Tween.get(launchSmoke, {loop: false})
          .to({alpha: 1, y: 370}, 400, Ease.linear);
      Tween.get(launchSmokeTwo, {loop: false})
          .to({alpha: 1}, 200, Ease.linear);
      Tween.get(launchSmokeThree, {loop: false})
          .to({alpha: 1, y: 370}, 600, Ease.linear);
      Tween.get(launchSmokeFour, {loop: false})
          .to({alpha: 1}, 600, Ease.linear);
      Tween.get(launchSmokeFive, {loop: false})
          .to({alpha: 1}, 1200, Ease.linear);
      Tween.get(launchSmokeFive, {loop: false})
          .to({y: 370}, 2000, Ease.linear);
      Tween.get(launchSmokeSix, {loop: false})
          .to({alpha: 1, y: 320}, 1000, Ease.linear);
      Tween.get(launchSmokeSeven, {loop: false})
          .to({alpha: 1}, 1000, Ease.linear);
      Tween.get(launchSmokeSeven, {loop: false})
          .to({y: 270}, 3000, Ease.linear);
      Tween.get(launchSmokeEight, {loop: false})
          .to({alpha: 1, y: 370}, 400, Ease.linear);
      Tween.get(launchSmokeNine, {loop: false})
          .to({alpha: 1}, 200, Ease.linear);
      Tween.get(launchSmokeTen, {loop: false})
          .to({alpha: 1, y: 370}, 600, Ease.linear);

  }, 3000);

  const inputs = {};

  inputs.mass = document.getElementById("mass").innerHTML;
  inputs.thrust = document.getElementById("thrust").innerHTML;
  inputs.thrust_time = document.getElementById("time").innerHTML;
  inputs.mass_change = $('#mass_change').is(":checked");
  inputs.drag = $('#drag').is(":checked");

  // Create a ticker that calls "handleTick" roughly every 50ms
  Ticker.addEventListener("tick", (e) => {
    handleTick(e, inputs);
  });

});

let data;
let statsModal;
let thrusterAnimation = false;
let shaker = false;
let shakerSlow = false;
let playSpeed = 10;

function updateProgressBar() {
  // get hte height value as a percentage of the progress made.
  let heightVal = 100- (data.height / constantsData.payloadHeight)
      * 100;

  // if the payload height has been passed, then max out the progress bar height.
  if (heightVal<=0) {
    heightVal = 0;
  }
  // if the rocket starts to fall, then do not lower the progress
  if(data.speed<=0){
    return;
  }
  document.getElementById("bar-img").style.clipPath =  "inset("+heightVal+"% 0% 0% 0%)";
}

/**
 * Update the browser url with the latest params that was run in this simulation.
 */
function updateURL(inputs) {
  //only update URL once
  if (urlUpdated) {
    return;
  }


  //remove previously set URL params and update with new ones.
  urlPush.removeAll();


  urlPush.add({key: 'urlHost', value: window.urlHostShare});

  urlPush.add({key: 'urlPage', value: window.urlPageShare});



  urlPush.add({key: 'thrust', value: inputs.thrust});
  urlPush.add({key: 'mass', value: inputs.mass});

  urlPush.add({key: 'thrust', value: inputs.thrust});
  urlPush.add({key: 'mass', value: inputs.mass});
  urlPush.add({key: 'thrustTime', value: inputs.thrust_time});
  if (!inputs.mass_change) {
    urlPush.add({key: 'mass_change', value: 'false'});
  } else {
    urlPush.add({key: 'mass_change', value: 'true'});
  }
  if (!inputs.drag) {
    urlPush.add({key: 'drag', value: 'false'});
  } else {
    urlPush.add({key: 'drag', value: 'true'});
  }

  //set the html text with the window URL location, and show the button.
  var currentsitepage = window.location.href.toString();
  var stripehttp =  currentsitepage.replace(/(^\w+:|^)\/\//, '');
  var currentsite = stripehttp.split('?')[0];
  var currentsite = decodeURIComponent(currentsite);
  var currentinnervariables = currentsitepage.split('?')[1];



  var finalstring = window.location.href.toString();
  if (urlPageShare) {
    var finalstring = window.location.href.toString();
    var finalstring = decodeURIComponent(finalstring);
    var finalstringvars = finalstring.split('?')[1];
    var finalstringvars = decodeURIComponent(finalstringvars);
    var finalstring = 'https://' + urlHostShare + '/' + urlPageShare + '?' + finalstringvars;
  } else {
    var finalstring = window.location.href.toString();
    var finalstring = decodeURIComponent(finalstring);
  }
  document.getElementById("rocket-URL-text").innerHTML = finalstring;

  $("#rocket-URL").show(200);

  urlUpdated = true;
}

var running = true;
var beenPaused = false;
var showingReset = true;

/**
 * Does the logic of the tick.  It updates
 * the simulation values and renders the output to the canvas.
 * @param e - Events
 * @param inputs - The inputs from the user controls
 */
function tickLogic(e, inputs) {
  if (running) {
    // Get simulation data for this tick
    data = activeSimulation(e, inputs, playSpeed);

    const currentStats = {
      mass:(Math.round(data.mass * 100) / 100),
      thrust: data.thrust,
      speed:Math.round(data.speed ),
      maxHeight: Math.round((maxHeight.text / 1000) * 100) / 100,
      sinceLaunch: (Math.round(data.time * 10) / 10),
      force:Math.round(data.resultantForceActingOnRocket),
      prevHeight: Math.round( previousHeight ),
      explodes: data.explodes
    };

    if(!statsModal){
      statsModal = createStatsModal({currentStats, rocket: inputs});
      statsModal.x = 30;
      statsModal.y = 25;
      stage.addChild(statsModal);

      $('#grad1').show(800);
      $('#bar-img').show();
      $('#rocket-play-speed-ul').show(800);



      Tween.get(statsModal, {loop: false})
          .to({alpha: 1}, 800, Ease.linear);

    }else{
      updateModal({currentStats, rocket: inputs});
    }
    // explosion logic
    if (data.explodes && data.maxHeight == "Infinity") {
      explodeOnLaunch();
    }
    //exploding in mid air.
    else if (data.explodes) {
      explodeMidAir();
    }

    //do this after rocket has launched.
    if (data.launched) {
      // move the clouds after the rocket has launched.
      if (data.height > 0) {
        animateClouds();
        updateProgressBar();
      }

      if (data.thruster == true) {

        if (shaker == false && data.thruster == true) {
          shaker = true;
          Tween.get(rocket, {loop: -1})
              .to({x: 389}, 200, Ease.linear)
              .to({x: 387}, 200, Ease.linear);

          Tween.get(biggerFlame, {loop: -1})
              .to({x: 386}, 200, Ease.linear)
              .to({x: 387}, 200, Ease.linear);

          Tween.get(biggerFlameTwo, {loop: -1})
              .to({x: 385}, 400, Ease.linear)
              .to({x: 386}, 400, Ease.linear);

        }

        if (data.height > 0) {
          //  thruster animation here
          liftOff();
        } else {

          Tween.get(launchFailureFlame, {loop: false})
              .to({alpha: 1}, 100, Ease.linear);
          Tween.get(launchExplosion, {loop: false})
              .to({alpha: 1}, 500, Ease.linear);
          Tween.get(launchExplosionTwo, {loop: false})
              .to({alpha: 1}, 500, Ease.linear);
          Tween.get(launchExplosionThree, {loop: false})
              .to({alpha: 1}, 500, Ease.linear);
          Tween.get(launchExplosionFour, {loop: false})
              .to({alpha: 1}, 500, Ease.linear);
          Tween.get(launchExplosion, {loop: false})
              .to({x: 300}, 0, Ease.linear);
          Tween.get(launchExplosionTwo, {loop: false})
              .to({x: 320}, 0, Ease.linear);
          Tween.get(launchExplosionThree, {loop: false})
              .to({x: 280}, 0, Ease.linear);
          Tween.get(launchExplosionFour, {loop: false})
              .to({x: 250}, 0, Ease.linear);

          Tween.get(launchExplosionLarge, {loop: false})
              .to({x: 100, y: 200, alpha: 1}, 100, Ease.linear);
          Tween.get(launchExplosionLargeTwo, {loop: false})
              .to({x: 100, y: 200, alpha: 1}, 100, Ease.linear);
          Tween.get(launchExplosionLargeThree, {loop: false})
              .to({x: 100, y: 200, alpha: 1}, 100, Ease.linear);
          Tween.get(launchExplosionLargeFour, {loop: false})
              .to({x: 100, y: 200, alpha: 1}, 100, Ease.linear);
          Tween.get(launchExplosionLargeFive, {loop: false})
              .to({x: 100, y: 200, alpha: 1}, 50, Ease.linear);
          Tween.get(launchExplosionLargeSix, {loop: false})
              .to({x: 100, y: 200, alpha: 1}, 20, Ease.linear);
          Tween.get(launchExplosionLargeSeven, {loop: false})
              .to({x: 120, y: 200, alpha: 1}, 20, Ease.linear);
          Tween.get(launchExplosionLargeNine, {loop: false})
              .to({x: 180, y: 200, alpha: 1}, 20, Ease.linear);
          Tween.get(launchExplosionLargeTen, {loop: false})
              .to({x: 150, y: 200, alpha: 1}, 20, Ease.linear);


        }

      } else {
        //fuel has run out, dont show thrusters.
        turnOffThrusters();
      }

      if (data.height >= 38000 && data.height < 76000) {

        //what is the difference of the tallest point minus the current height
        var skyw = '85000' - Math.round(data.height);
        //Times this difference by two
        var skyx = skyw * 2;
        //Make it a decimal
        var skyy = "." + skyx;
        //If x is less than 1500 then just set as 0 to avoid mismatch
        if (skyx < 1200) {
          var skyy = '0';
        }
        //what is 1 minus the current double height difference
        var skyz = '1' - skyy;
        //set up rgba
        fillCommand.style = "rgba(33,33,189," + skyz + ")";
      }
      if (data.height >= 60000 && data.height < 90000) {
        //what is the difference of the tallest point minus the current height
        var spacew = '100000' - Math.round(data.height);
        //Times this difference by two
        var spacex = spacew * 2;
        //Make it a decimal
        var spacey = "." + spacex;
        //If x is less than 1500 then just set as 0 to avoid mismatch
        if (spacex < 1200) {
          var spacey = '0';
        }
        //what is 1 minus the current double height difference
        var spacez = '1' - spacey;
        //set up rgba
        fillCommandSpace.style = "rgba(4,4,4," + spacez + ")";

        //waterbg even more hidden
        if (inSpace == false) {
          inSpace = true;

          Tween.get(waterColorOne, {loop: false})
              .to({alpha: 0.04}, 5000, Ease.linear);
          Tween.get(waterColorTwo, {loop: false})
              .to({alpha: 0.04}, 5000, Ease.linear);
          Tween.get(waterColorThree, {loop: false})
              .to({alpha: 0.04}, 5000, Ease.linear);
          Tween.get(waterColorFour, {loop: false})
              .to({alpha: 0.04}, 5000, Ease.linear);
        }

      }

      if (data.height >= data.maxHeight) {

        if (shakerSlow == false && data.thruster == false) {
          shakerSlow = true;
          if (data.height > 0) {
            Tween.get(rocket, {loop: -1})
                .to({x: 389}, 800, Ease.linear)
                .to({x: 387}, 800, Ease.linear);


          } else {
            Tween.get(rocket, {loop: -1})
                .to({x: 388}, 10000, Ease.linear)
                .to({x: 388}, 10000, Ease.linear);
          }
        }



        if (data.height >= 9000 && vFormation == false) {
          vFormation = true;
          Tween.get(geese, {loop: false})
              .to({y: 700}, 1000, Ease.linear);
        }
        if (data.height >= 19000 && smallPlane == false) {
          smallPlane = true;
          Tween.get(lowLevelPlane, {loop: false})
              .to({y: 700}, 1000, Ease.linear);
        }
        if (data.height >= 12000 && largePlane == false) {
          largePlane = true;
          Tween.get(highLevelPlane, {loop: false})
              .to({y: 700}, 1000, Ease.linear);
        }

      } else {
        //It is over so check if height limit reached
        if (data.height >= constantsData.payloadHeight && payloadDeploy
            === false) {

          // change playspeed back to 1 when simulation has ended
          document.getElementById('x1').checked = true;
          playSpeed=1;

          payloadDeploy = true;
          Tween.get(rocketBody, {loop: false})
              .to({y: 700}, 3000, Ease.linear);

          Tween.get(rocketPayload, {loop: false})
              .to({y: 100, alpha: 0}, 1000, Ease.linear);

          Tween.get(rocketPayloadLeft, {loop: false})
              .to({y: 200, alpha: 1}, 1000, Ease.linear);

          Tween.get(rocketPayloadRight, {loop: false})
              .to({y: 200, alpha: 1}, 1000, Ease.linear);

          setTimeout(() => {
            if (running) {
              Tween.get(rocketBody, {loop: false})
                  .to({y: 1000}, 4000, Ease.linear);
            }
          }, 2000);

          setTimeout(() => {
            if (running) {
              Tween.get(rocketPayloadLeft, {loop: false})
                  .to({x: -100, y: 800, rotation: -45, scale: .2}, 5000,
                      Ease.linear);

              Tween.get(rocketPayloadRight, {loop: false})
                  .to({x: 900, y: 800, rotation: 45, scale: .2}, 5000, Ease.linear);

              Tween.get(satellite, {loop: false})
                  .to({alpha: 1}, 100, Ease.linear);

              Tween.get(satellite, {loop: false})
                  .to({scale: .5}, 6000, Ease.linear);

              Tween.get(satellite, {loop: false})
                  .to({rotation: 40}, 10000, Ease.linear);
            }
          }, 3000);

          setTimeout(() => {
            if (running) {
              payloadRelease = true;
            }
          }, 11000);

        } else if (data.height < constantsData.payloadHeight && payloadDeploy
            == false && !falling) {

          falling = true;

          Tween.get(rocket, {loop: false})
              .to({y: 120}, 2000, Ease.linear);

          Tween.get(launchSmoke, {loop: false})
              .to({alpha: 1}, 400, Ease.linear);
          Tween.get(launchSmokeFour, {loop: false})
              .to({alpha: 1}, 400, Ease.linear);
          Tween.get(launchSmokeTen, {loop: false})
              .to({alpha: 1}, 400, Ease.linear);
          Tween.get(launchSmokeFive, {loop: false})
              .to({alpha: 1}, 400, Ease.linear);
          Tween.get(launchSmokeSix, {loop: false})
              .to({alpha: 1}, 400, Ease.linear);

          setTimeout(() => {
            if (running) {
              Tween.get(warningLight, {loop: -1})
                  .to({alpha: 1, x: 399}, 100, Ease.none)
                  .to({alpha: 0, x: 401}, 100, Ease.none);
            }
          }, 2000);
        }

        // Show thrusters (color change)
        if (!thrusterAnimation && data.thruster) {
          thrusterAnimation = true;
        }
        // Or if they're done turn them off
        if (thrusterAnimation && !data.thruster) {
          thrusterAnimation = false;
        }
      }
    }

    var currentHeight = data.height;
    heightTally.text = currentHeight;
    if (data.height >= data.maxHeight) {
      maxHeight.text =  Number ( currentHeight );
      var maxHeightNumber = Number ( currentHeight );
      var maxHeightNumberMath = (Math.round((maxHeight.text / 1000) * 100) / 100) ;
    }

    if ((data.ended || payloadRelease == true) && !resultModal) {

      // change playspeed back to 1 when simulation has ended
      document.getElementById('x1').checked = true;
      playSpeed=1;

      const stats = {
        maxHeight: Math.round((maxHeight.text / 1000) * 100) / 100,
        maxSpeed: Math.round(data.maxSpeed),
        timeToMaxHeight: Math.round(data.timeToMaxHeight),
        prevHeight: Math.round( previousHeight ) ,
      };
      resultsTimeout = setTimeout(() => {
        if (running && !resultModal) {
          nextPreviousHeight = (Math.round((maxHeight.text / 1000) * 100) / 100);

          var status = 'success';
          if (data.explodes) {
            status = 'exploded';
          } else if (maxHeight.text == 0) {
            status = 'fail';
          } else if (maxHeight.text <= constantsData.payloadHeight && !data.explodes) {
            status = 'partial';
          }

          resultModal = createResultModal({status, stats, rocket: inputs, imageQueue: queue});
          resultModal.x = 40;
          resultModal.y = 40;
          stage.addChild(resultModal);

          Tween.get(resultModal, {loop: false})
              .to({alpha: 1}, 250, Ease.linear);

          $('#bar-img').hide(400);
          $('#grad1').hide(800);
          $('#rocket-play-speed-ul').hide(800);
        }
      },2000);

      setTimeout(() => {
        if (running) {
          // this will update the url on the browser window with the latest url from
          // the simulation.
          updateURL(inputs);
          Ticker.reset();
          running = false;
        }
      }, 2500);

      restartTimeout = setTimeout(() => {
          if (!showingReset && $("#rocket-wrapper").hasClass("sim-active")) {
              $("#rocket-restart").show();
              showingReset = true;
          }
          // Timeout needs to be this long to allow for phantom ticks that need to run out before we reset
      }, 3000);
    }
  }
}

/**
 * This is the tick function that is called at every tick interval. It calls tickLogic
 * function with a timeout of required
 * @param e - Events
 * @param inputs - The inputs from the user controls
 */
function handleTick(e, inputs) {
  // Simulation is paused, screen doesnt change
  if (!e.paused) {
    if (!beenPaused) {
      //Delay init for countdown effect
      mainTimeout = setTimeout(tickLogic, 6000, e, inputs);
    } else {
      tickLogic(e, inputs);
    }
    stage.update();
  }
}

$('#rocket-restart').on('click', () => {
  running = false;
  Tween._inited = false;
  restart();
  launchTimeout = null;
  mainTimeout = null;
  restartTimeout = null;
  resultsTimeout = null;
  data = null;
});

function restart() {
  Tween.removeAllTweens();
  stage.removeAllChildren();
  reset();
  createObjects();
  fillPrevHeight();
  setStage();
  // reset the progress bar
  document.getElementById("bar-img").style.clipPath =  "inset(100% 0% 0% 0%)";
  document.getElementById("rocket-controls").style.zIndex=1;
  $('#grad1').hide();
  $('#rocket-play-speed-ul').hide();
  $("#challenge-box").show(400);
  document.getElementById('x5').checked = true;
  playSpeed=10;

  beenPaused = false;
  falling = false;
  urlUpdated = false;
  paramsUpdated = false;
  thrusterAnimation = false;
  shaker = false;
  shakerSlow = false;
  // reset the stats bar
  statsModal = null;
  resultModal= null;
  stage.update();
}

/**
* Fills the max height from the previous launch
 */
function fillPrevHeight() {
  previousHeight = nextPreviousHeight;
  firstLaunch = false;
}

$('#rocket-pause').on('click', () => {
  const currentStatus = Ticker.paused;
  Ticker.paused = !currentStatus;
});

$("input[name='play_speed']").change(function () {
  if (this.value === "pause") {
    running = false;
    beenPaused = true;
    Ticker.paused = true;
  } else {
    running = true;
    Ticker.paused = false;
    playSpeed = this.value;
  }
});

/**
 * Launch pad graphics are initialised and rendered here.
 */
function initialiseLaunchPad() {

  Tween.get(launchItems, { loop: false})
    .to({scale: 1, y: 325}, 1000, Ease.linear);

  Tween.get(sunReflection, {loop: -1})
  .to({x: 515}, 5000, Ease.linear)
  .to({x: 545}, 5000, Ease.linear)
  .to({x: 515}, 5000, Ease.linear);

  Tween.get(sunReflectionTwo, {loop: -1})
  .to({x: 620}, 5000, Ease.linear)
  .to({x: 590}, 5000, Ease.linear)
  .to({x: 620}, 5000, Ease.linear);

  //Hide Lab

  Tween.get(leftWall, {loop: false})
  .to({x: -100}, 6300, Ease.linear);

  Tween.get(rightWall, {loop: false})
  .to({x: 100}, 3000, Ease.linear);

  Tween.get(topWall, {loop: false})
  .to({y: -100}, 3000, Ease.linear);

  Tween.get(windowGlass, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);

  //Countdown
  Tween.get(countdownThree, {loop: false})
  .to({alpha: 1}, 100, Ease.linear)
  .wait(800)
  .to({alpha: 0}, 100, Ease.linear);

  Tween.get(countdownTwo, {loop: false})
  .wait(1000)
  .to({alpha: 1}, 100, Ease.linear)
  .wait(800)
  .to({alpha: 0}, 100, Ease.linear);

  Tween.get(countdownOne, {loop: false})
  .wait(2000)
  .to({alpha: 1}, 100, Ease.linear)
  .wait(800)
  .to({alpha: 0}, 100, Ease.linear);

  Tween.get(bg, {loop: false})
  .wait(2200)
  .to({alpha: 1}, 400, Ease.linear);

}

/**
 * Animations for exploding the rocket while it's still on the launch pad.
 */
function explodeOnLaunch() {
  //Rocket Sinks Downwards
  Tween.get(rocketBody, {loop: false})
  .to({y: 500, rotation: 5}, 6000, Ease.linear);

  Tween.get(rocketPayload, {loop: false})
  .to({y: 500}, 6000, Ease.linear);

  Tween.get(biggerFlame, {loop: false})
  .to({alpha: 0}, 100, Ease.linear);

  //Flames appear
  //Review BITMAP scale here
  //http://blog.createjs.com/scaling-and-stretching-with-the-scalebitmap-class/
  Tween.get(launchExplosion, {loop: false})
  .to({alpha: 1, y: 370, scale: 6}, 400, Ease.linear);
  Tween.get(launchExplosionTwo, {loop: false})
  .to({alpha: 1, scale: 6}, 200, Ease.linear);
  Tween.get(launchExplosionThree, {loop: false})
  .to({alpha: 1, y: 370, scale: 2}, 600, Ease.linear);
  Tween.get(launchExplosionFour, {loop: false})
  .to({alpha: 1, scale: 3}, 600, Ease.linear);
  Tween.get(launchExplosionFive, {loop: false})
  .to({alpha: 1, scale: 3}, 1200, Ease.linear);
  Tween.get(launchExplosionFive, {loop: false})
  .to({y: 370, scale: 3}, 2000, Ease.linear);
  Tween.get(launchExplosionSix, {loop: false})
  .to({alpha: 1, y: 320, scale: 3}, 1000, Ease.linear);
  Tween.get(launchExplosionSeven, {loop: false})
  .to({alpha: 1, scale: 3}, 1000, Ease.linear);
  Tween.get(launchExplosionSeven, {loop: false})
  .to({y: 270, scale: 3}, 3000, Ease.linear);
  Tween.get(launchExplosionEight, {loop: false})
  .to({alpha: 1, y: 370, scale: 3}, 400, Ease.linear);
  Tween.get(launchExplosionNine, {loop: false})
  .to({alpha: 1, scale: 2}, 200, Ease.linear);
  Tween.get(launchExplosionTen, {loop: false})
  .to({alpha: 1, y: 370, scale: 2}, 600, Ease.linear);

  Tween.get(launchExplosionLarge, {loop: false})
  .to({alpha: 1, y: 170, x: 170, scale: 6}, 400, Ease.linear);
  Tween.get(launchExplosionLargeTwo, {loop: false})
  .to({alpha: 1, x: 70, scale: 1}, 200, Ease.linear);
  Tween.get(launchExplosionLargeThree, {loop: false})
  .to({alpha: 1, x: 70, y: 270, scale: 1}, 600, Ease.linear);
  Tween.get(launchExplosionLargeFour, {loop: false})
  .to({alpha: 1, x: 70, scale: 1}, 300, Ease.linear);
  Tween.get(launchExplosionLargeFive, {loop: false})
  .to({alpha: 1, x: 70, scale: 1}, 200, Ease.linear);
  Tween.get(launchExplosionLargeFive, {loop: false})
  .to({y: 270, x: 170, scale: 1}, 1000, Ease.linear);
  Tween.get(launchExplosionLargeSix, {loop: false})
  .to({alpha: 1, x: 70, y: 20, scale: 1}, 1000, Ease.linear);
  Tween.get(launchExplosionLargeSeven, {loop: false})
  .to({alpha: 1, x: 170,scale: 1}, 1000, Ease.linear);
  Tween.get(launchExplosionLargeSeven, {loop: false})
  .to({y: 270, x: 70, scale: 1}, 1000, Ease.linear);
  Tween.get(launchExplosionLargeEight, {loop: false})
  .to({alpha: 1, x: 170, y: 270, scale: 1}, 400, Ease.linear);
  Tween.get(launchExplosionLargeNine, {loop: false})
  .to({alpha: 1, x: 170, scale: 1}, 200, Ease.linear);
  Tween.get(launchExplosionLargeTen, {loop: false})
  .to({alpha: 1, x: 170, y: 170, scale: 1}, 600, Ease.linear);
}

/**
 * Animations for exploding the rocket mid air.
 */
function explodeMidAir() {
  //Rocket Sinks Downwards
  Tween.get(rocketBody, {loop: false})
  .to({y: 500, rotation: -10}, 1000, Ease.linear);

  Tween.get(rocketPayload, {loop: false})
  .to({alpha: 0, y: 500}, 200, Ease.linear);

  Tween.get(rocketPayloadLeft, {loop: false})
  .to({alpha: 1, y: 500, x: -100, rotation: -30}, 100, Ease.none);

  Tween.get(rocketPayloadRight, {loop: false})
  .to({alpha: 1, y: 200, x: 900, rotation: 30}, 70, Ease.none);

  Tween.get(biggerFlame, {loop: false})
  .to({alpha: 0}, 0, Ease.linear);
  Tween.get(biggerFlameTwo, {loop: false})
  .to({alpha: 0}, 0, Ease.linear);

  //Flames appear
  Tween.get(launchExplosion, {loop: false})
  .to({alpha: 1, x: -100, y: 370, scale: 2}, 400, Ease.linear);
  Tween.get(launchExplosionTwo, {loop: false})
  .to({alpha: 1, y: 370, scale: 3}, 200, Ease.linear);
  launchExplosionThree.y = 200;
  launchExplosionFour.y = 200;
  launchExplosionFive.y = 200;
  launchExplosionSeven.y = 200;
  launchExplosionNine.y = 200;
  launchExplosionTen.y = 200;
  Tween.get(launchExplosionThree, {loop: false})
  .to({alpha: 1, y: 100, scale: 2}, 600, Ease.linear);
  Tween.get(launchExplosionFour, {loop: false})
  .to({alpha: 1, scale: 2}, 600, Ease.linear);
  Tween.get(launchExplosionFive, {loop: false})
  .to({alpha: 1, scale: 3}, 1200, Ease.linear);
  Tween.get(launchExplosionFive, {loop: false})
  .to({y: 100, scale: 3}, 200, Ease.linear);
  Tween.get(launchExplosionSix, {loop: false})
  .to({alpha: 1, y: 100, scale: 3}, 1000, Ease.linear);
  Tween.get(launchExplosionSeven, {loop: false})
  .to({alpha: 1, scale: 2}, 100, Ease.linear);
  Tween.get(launchExplosionSeven, {loop: false})
  .to({y: 200, scale: 2}, 1000, Ease.linear);
  Tween.get(launchExplosionEight, {loop: false})
  .to({alpha: 1, y: 100, scale: 3}, 400, Ease.linear);
  Tween.get(launchExplosionNine, {loop: false})
  .to({alpha: 1, x: 110, y: 200, scale: 2}, 200, Ease.linear);
  Tween.get(launchExplosionTen, {loop: false})
  .to({alpha: 1, y: 100, scale: 2}, 600, Ease.linear);

  Tween.get(launchExplosionLarge, {loop: false})
      .to({x: 100, y: 100, alpha: 1}, 100, Ease.linear);
  Tween.get(launchExplosionLargeTwo, {loop: false})
      .to({x: 100, y: 100, alpha: 1, scale: 2}, 100, Ease.linear);
  Tween.get(launchExplosionLargeThree, {loop: false})
      .to({x: 100, y: 100, alpha: 1, scale: 2}, 100, Ease.linear);
  Tween.get(launchExplosionLargeFour, {loop: false})
      .to({x: 100, y: 100, alpha: 1, scale: 2}, 100, Ease.linear);
  Tween.get(launchExplosionLargeFive, {loop: false})
      .to({x: 100, y: 100, alpha: 1}, 500, Ease.linear);
  Tween.get(launchExplosionLargeSix, {loop: false})
      .to({x: 100, y: 100, alpha: 1}, 200, Ease.linear);
  Tween.get(launchExplosionLargeSeven, {loop: false})
      .to({x: 20, y: 100, alpha: 1}, 200, Ease.linear);
  Tween.get(launchExplosionLargeNine, {loop: false})
      .to({x: 80, y: 200, alpha: 1}, 200, Ease.linear);
  Tween.get(launchExplosionLargeTen, {loop: false})
      .to({x: 50, y: 200, alpha: 1}, 200, Ease.linear);
}

/**
 * Animations for the rocket lifting off from the launchpad.
 */
function liftOff() {
  //Lift Off
  Tween.get(platformFlame, {loop: false})
  .to({alpha: 1}, 0, Ease.linear);

  if(!data.explodes){
    Tween.get(biggerFlame, {loop: false})
    .to({alpha: 1}, 1000, Ease.linear);

    Tween.get(biggerFlameTwo, {loop: false})
    .to({alpha: 1}, 1000, Ease.linear);
  }

  Tween.get(biggerFlame, {loop: false})
  .to({y: 400}, 200, Ease.linear);

  Tween.get(biggerFlameTwo, {loop: false})
  .to({y: 400}, 200, Ease.linear);


  Tween.get(rocket, {loop: false})
  .to({y: 70}, 200, Ease.linear);

  //Landscape lowers
  Tween.get(launchSmokeLarge, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeLargeTwo, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeLargeThree, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeLargeFour, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeLargeFive, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeLargeSix, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeLargeSeven, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeLargeEight, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeLargeNine, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeLargeTen, {loop: false})
  .to({y: 700}, 300, Ease.linear);

  Tween.get(launchSmoke, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeTwo, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeThree, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeFour, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeFive, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeSix, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeSeven, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeEight, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeNine, {loop: false})
  .to({y: 700}, 300, Ease.linear);
  Tween.get(launchSmokeTen, {loop: false})
  .to({y: 700}, 300, Ease.linear);

  Tween.get(grass, {loop: false})
  .to({y: 700}, 300, Ease.linear);

  Tween.get(platform, {loop: false})
  .to({y: 700}, 300, Ease.linear);

  Tween.get(platformFlame, {loop: false})
  .to({y: 700}, 300, Ease.linear);

  Tween.get(crane, {loop: false})
  .to({y: 700}, 300, Ease.linear);

  //Sea lowers
  Tween.get(sea, {loop: false})
  .to({y: 700}, 500, Ease.linear);
  Tween.get(sunReflection, {loop: false})
  .to({y: 700, alpha: .1}, 500, Ease.linear);
  Tween.get(sunReflectionTwo, {loop: false})
  .to({y: 700, alpha: .1}, 500, Ease.linear);
  Tween.get(sun, {loop: false})
  .to({y: 700}, 600, Ease.linear);
}

/**
 * Animations for turning the thrusters off.
 */
function turnOffThrusters() {
  Tween.get(biggerFlame, {loop: false})
  .to({alpha: 0}, 100, Ease.linear);
  Tween.get(biggerFlameTwo, {loop: false})
  .to({alpha: 0}, 100, Ease.linear);

  Tween.get(launchFailureFlame, {loop: false})
  .to({alpha: 0}, 100, Ease.linear);
  Tween.get(launchExplosion, {loop: false})
  .to({alpha: 0}, 500, Ease.linear);
  Tween.get(launchExplosionTwo, {loop: false})
  .to({alpha: 0}, 500, Ease.linear);
  Tween.get(launchExplosionThree, {loop: false})
  .to({alpha: 0}, 500, Ease.linear);
  Tween.get(launchExplosionFour, {loop: false})
  .to({alpha: 0}, 500, Ease.linear);

  Tween.get(launchSmokeLarge, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeLargeTwo, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeLargeThree, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeLargeFour, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeLargeFive, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeLargeSix, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeLargeSeven, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeLargeEight, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeLargeNine, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeLargeTen, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);

  Tween.get(launchSmoke, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeTwo, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeThree, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeFour, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeFive, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeSix, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeSeven, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeEight, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeNine, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
  Tween.get(launchSmokeTen, {loop: false})
  .to({alpha: 0}, 1000, Ease.linear);
}

/**
 * Animate the clouds with respect to the rocket speed. The cloud speed constant
 * can be set in the constants config file.
 */
function animateClouds() {
  // check if the clouds are out of bounds of the screen.
  // move them back at the top of the screen.
  if (waterColorOne.y >= 800) {
    waterColorOne.y = -800;
  }
  if (waterColorTwo.y >= 800) {
    waterColorTwo.y = -800;
  }
  if (waterColorThree.y >= 800) {
    waterColorThree.y = -800;
  }
  if (waterColorFour.y >= 800) {
    waterColorFour.y = -800;
  }

  // calculate the speed at which the clouds move, proportional to the rocket speed.
  let val = (data.speed / 2000) * constantsData.cloudSpeed * playSpeed;
  if (val >= constantsData.cloudSpeed) {
    val = constantsData.cloudSpeed;
  }

  // tween the clouds here based on the speed.
  Tween.get(waterColorOne, {loop: false})
  .to({y: waterColorOne.y}, 1, Ease.linear)
  .to({y: waterColorOne.y + (val * 0.2)}, 1, Ease.linear);

  Tween.get(waterColorTwo, {loop: false})
  .to({y: waterColorTwo.y}, 1, Ease.linear)
  .to({y: waterColorTwo.y + (val * 0.4)}, 1, Ease.linear);

  Tween.get(waterColorThree, {loop: false})
  .to({y: waterColorThree.y}, 1, Ease.linear)
  .to({y: waterColorThree.y + (val * 0.8)}, 1, Ease.linear);

  Tween.get(waterColorFour, {loop: false})
  .to({y: waterColorFour.y}, 1, Ease.linear)
  .to({y: waterColorFour.y + (val * 1)}, 1, Ease.linear);
}
